import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import GuardianRoute from '../../shared/GuardianRoute';
import FacturasGlobales from './list/FacturasGlobales';
import FacturasGlobalesTicketInfo from './info/FacturasGlobalesTicketInfo';

const FacturasGlobalesRoutes = () => {
  return (
    <Switch>
      <Redirect
        from="/modulos/fpg"
        to="/modulos/fpg/tickets"
        exact
      />
      <GuardianRoute
        path="/modulos/fpg/tickets"
        component={FacturasGlobales}
        can="autofacturacion.listar.tickets"
        exact
      />
      <GuardianRoute
        path="/modulos/fpg/tickets/:id/info"
        component={FacturasGlobalesTicketInfo}
        can="autofacturacion.info.tickets"
        exact
      />
    </Switch>
  );
};

export default FacturasGlobalesRoutes;
